// extracted by mini-css-extract-plugin
export default {"link":"MtuN4l891n9ZroxxIjjR","show-more":"IBdxEP_Me17rFoEzJFit"};